export var GET_ONLINE_TEST_LOG = 'GET_ONLINE_TEST_LOG';
export var SUCCESS_GET_ONLINE_TEST_LOG = 'SUCCESS_GET_ONLINE_TEST_LOG';
export var FAILURE_GET_ONLINE_TEST_LOG = 'FAILURE_GET_ONLINE_TEST_LOG';